import { Component, OnInit, Renderer2, ViewChild, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { MessageService } from 'services/message/message.service';
import { environment } from '../environments/environment';
import { Theme } from 'services/broadcast.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { SessionExpiredComponent } from './sessionexpired/session-expired.component';
import { AuthService } from 'core';
import { LocalStorageService } from 'services/local-storage/local-storage.service';
import { AffiliateService } from './affiliate/affiliate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);
  private readonly renderer = inject(Renderer2);
  private readonly toastrService = inject(ToastrService);
  private readonly modalService = inject(BsModalService);
  private readonly authService = inject(AuthService);
  private readonly localStorageService = inject(LocalStorageService);

  @ViewChild(ToastContainerDirective, { static: true }) toastContainer: ToastContainerDirective;

  title = 'coinzoom';
  showHeaderFooter = false;
  simple = environment.simple;
  theme = this.simple ? Theme.day : this.localStorageService.getThemeType();

  constructor() {
    inject(AffiliateService); // Eager load is needed to invite the user in the background.
  }

  ngOnInit() {
    this.messageService.notifications.subscribe((errorObj) => {
      if (errorObj.status === 401) {
        this.authService.clearAuthData();
        this.router.navigate(['/landing']).then((_) => this.showSessionExpired());
      }
    });

    this.themeChange(this.theme);
    this.initToaster();
  }

  private initToaster(): void {
    this.toastrService.overlayContainer = this.toastContainer;
    this.toastrService.toastrConfig.positionClass = 'toast-right-here';
  }

  onActivate() {
    this.showHeaderFooter =
      !this.router.url.includes('/web-chart')
      && !this.router.url.includes('/chartpopout')
      && !this.router.url.includes('paysafe-callback')
      && this.router.url !== '/404';
  }

  themeChange(theme: Theme) {
    this.localStorageService.setThemeType(theme);
    this.theme = theme;
    if (theme === Theme.night) {
      this.renderer.addClass(document.body, 'themeNight');
    } else {
      this.renderer.removeClass(document.body, 'themeNight');
    }
  }

  private showSessionExpired(): void {
    if (!SessionExpiredComponent.isShown) {
      this.modalService.show(SessionExpiredComponent, {
        class: 'modal-sm',
      });
    }
  }

  protected navigating = computed(() => !!this.router.currentNavigation());
}
